export const APP_GET_DATA = 'APP_GET_DATA';
export const APP_GET_DATA_SUCCESS = 'APP_GET_DATA_SUCCESS';
export const APP_GET_DATA_FAILURE = 'APP_GET_DATA_FAILURE';

export const appGetData = () => {
  return {
    type: APP_GET_DATA
  };
};

export const appGetDataSuccess = payload => {
  return {
    type: APP_GET_DATA_SUCCESS,
    payload
  };
};

export const appGetDataFailure = payload => {
  return {
    type: APP_GET_DATA_FAILURE,
    payload,
    error: true
  };
};




// WEBPACK FOOTER //
// ./src/actions/index.js